/* eslint-disable */
import React from "react";
import { Grid } from "@material-ui/core";
import CustomSelect from "../../../../forms/selects/CustomSelect";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../redux";

interface PaymentOptionDropDownParams {
  value: string;
  onChange: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(
      field: T_1
    ): T_1 extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
  orderIsFreeOfCharge: boolean;
  userHasNoOrganizations: boolean;
  grossPrice: number;
  giropayIsAvailable: boolean;
}

export const PaymentOptionDropDown: React.FC<PaymentOptionDropDownParams> = (
  props: PaymentOptionDropDownParams
) => {
  const { t } = useTranslation(["booking", "snackbars"]);
  const {
    orderIsFreeOfCharge,
    giropayIsAvailable,
    userHasNoOrganizations,
    grossPrice,
    onChange,
    value,
  } = props;
  const paymentOptions = [];

  const paypalLabel = giropayIsAvailable
    ? "paymentOptions.methodPayPal"
    : "paymentOptions.methodPayPalNoGiropay";

  if (orderIsFreeOfCharge || !userHasNoOrganizations) {
    paymentOptions.push({
      key: "Rechnung",
      value: "Rechnung",
      label: t("paymentOptions.methodInvoice", { ns: "booking" }),
    });
  }

  const featureFlags = useSelector((state: AppState) => state.featureFlagging);

  const paypalIsActive: boolean = featureFlags.featureFlags.paypal_payment_is_enabled;
  const stripeIsActive: boolean = featureFlags.featureFlags.stripe_payment_is_enabled;
  const prepaymentIsActive: boolean =
    featureFlags.featureFlags.prepay_payment_is_enabled;

  if (!orderIsFreeOfCharge) {
    if (paypalIsActive && grossPrice >= 0.01) {
      paymentOptions.push({
        key: "PayPal",
        value: "PayPal",
        label: t(paypalLabel, { ns: "booking" }),
      });
    }
    if (stripeIsActive && grossPrice >= 0.5) {
      paymentOptions.push({
        key: "Stripe",
        value: "Stripe",
        label: t("paymentOptions.methodStripe", { ns: "booking" }),
      });
    }
    if (prepaymentIsActive) {
      paymentOptions.push({
        key: "Vorkasse per Banküberweisung",
        value: "Vorkasse per Banküberweisung",
        label: t("paymentOptions.methodPrepayment", { ns: "booking" }),
      });
    }
  }
  return (
    <Grid item xs={12} sm={6} style={{ padding: "5rem 0 2.5rem 0" }}>
      <CustomSelect
        name="payment_method"
        id="payment_method"
        labelId="payment_method_label"
        label={t("paymentOptions.paymentMethod", { ns: "booking" })}
        onChange={onChange}
        value={value}
        options={paymentOptions}
        required
      />
    </Grid>
  );
};
